// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"e38a8387","125":"e0ab6749","162":"f59fe41c","303":"1011b8e3","315":"5b6170d9","641":"517acf3e","746":"9dd3006e","832":"fd60f7d4","970":"1ec4b631"}[chunkId] + ".chunk.js";
};